export function getExtenstion(fileName: string): string {
  return fileName?.slice(((fileName?.lastIndexOf('.') - 1) >>> 0) + 2);
}
